import { Alert, Form, FormControl, TextInput, Button } from 'callahan-react'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import DeveloperKeys from './DeveloperKeys'
import NetworksTable from './NetworksTable'
import UserTable from './UserTable'
import { clearErrors, fetchNewAPIKey, fetchUserInfo } from '../../actions/user-info-actions'
import BackButton from '../../components/BackButton'
import { getOldAuthNUrl } from '../../utils/url-utils.js'

import './user-info.css'
import '../default.css'

const propTypes = {
  errors: PropTypes.object,
  isFetchingUserInfo: PropTypes.bool,
  fetchUserInfoError: PropTypes.bool,
  userInfoData: PropTypes.object
}

const initialState = {
  validationMessage: '',
  email: '',
  loadingAPIKey: false,
  showTable: false,
  showNetworkData: false,
  showDevData: false,
  showError: false
}

export class UserInfo extends Component {
  constructor(props) {
    super(props)
    this.state = initialState
  }

  handleEmailChange = event => {
    const email = event.target.value
    this.setState({ email, validationMessage: '' })
  }

  enterToSubmit = event => {
    if (event.which === 13) {
      this.submitForm()
      event.preventDefault()
    }
  }

  submitForm = () => {
    const { email } = this.state

    if (email === '') {
      this.setState({ validationMessage: 'User email must not be blank' })
      return
    }
    let atPos = email.indexOf('@')
    let dotPos = email.indexOf('.', atPos)
    if (atPos === -1 || dotPos === -1) {
      this.setState({ validationMessage: 'Malformed user email' })
      return
    }

    this.setState({ showTable: false })

    let query = new URLSearchParams()
    query.append('email', email)
    this.props.dispatch(fetchUserInfo(query.toString())).then(() => {
      const { userInfoData, fetchUserInfoError } = this.props
      let showTable = userInfoData && !fetchUserInfoError
      const showDevData =
        userInfoData && userInfoData.developer_keys && userInfoData.developer_keys.length > 0
      this.setState({
        showTable,
        showNetworkData: userInfoData ? userInfoData.networks : false,
        showDevData,
        showError: !showTable
      })
    })
  }

  getNewAPIKey = () => {
    this.props.dispatch(clearErrors())
    const { email } = this.state
    this.setState({ loadingAPIKey: true })
    this.props.dispatch(fetchNewAPIKey(email)).then(() => {
      const { userInfoData } = this.props
      const showDevData =
        userInfoData && userInfoData.developer_keys && userInfoData.developer_keys.length > 0

      this.setState({
        loadingAPIKey: false,
        showDevData
      })
    })
  }

  resetPage = () => {
    this.setState(initialState)
  }

  render() {
    const data = this.props.userInfoData
    const { errors } = this.props
    const { developerKeyError } = errors
    const {
      email,
      loadingAPIKey,
      validationMessage,
      showError,
      showTable,
      showNetworkData,
      showDevData
    } = this.state

    const authNButton =
      showTable && data.user ? (
        <div>
          <form method="POST" action={getOldAuthNUrl()}>
            <input type="hidden" name="email" value={data.user.email} />
            <Button buttonType="secondary" type="submit">
              Go To Page
            </Button>
          </form>
        </div>
      ) : null

    return (
      <div className="main-content">
        <div className="title-bar">
          <BackButton onClick={this.resetPage} />
          <h1 className="page-title">User Info</h1>
          <div className="title-right-padding" />
        </div>
        <hr />
        <div className="ui-content">
          <Form className="ui-form">
            <FormControl
              value={email}
              label="Enter User Email"
              className={validationMessage !== '' ? 'form-control--error' : ''}
              hint={validationMessage}
            >
              <div className="ui-form-wrapper">
                <TextInput
                  className="ui-input"
                  placeholder="..."
                  value={email}
                  onChange={this.handleEmailChange}
                  onKeyPress={this.enterToSubmit}
                />
                <Button
                  buttonType="primary"
                  buttonMode="small"
                  className="ui-button"
                  onClick={this.submitForm}
                  loading={this.props.isFetchingUserInfo}
                >
                  View User
                </Button>
              </div>
            </FormControl>
          </Form>

          {showError && (
            <div className="ui-error-alert">
              <Alert
                color="error"
                title={typeof data !== 'undefined' ? data.message : 'Could not connect'}
              />
            </div>
          )}

          {showTable && (
            <div className="ui-data">
              <Alert
                className="ui-more-actions-alert"
                title="More Actions"
                description="Impersonate, Edit, Delete, and Resend Confirmation"
                buttons={authNButton}
              />

              <h2 className="ui-header">User Information</h2>
              <UserTable displayData={[data.user]} />

              {showNetworkData && (
                <div>
                  <h2 className="ui-header">User Networks Information</h2>
                  <NetworksTable displayData={data.networks} />
                </div>
              )}

              <DeveloperKeys
                developerKeyError={developerKeyError}
                displayData={data.developer_keys}
                loading={loadingAPIKey}
                onClick={this.getNewAPIKey}
                showDevData={showDevData}
              />
            </div>
          )}
        </div>
      </div>
    )
  }
}

UserInfo.propTypes = propTypes

function mapStateToProps(state) {
  const { errors = {}, userInfo } = state
  return {
    errors,
    isFetchingUserInfo: userInfo.isFetchingUserInfo,
    fetchUserInfoError: userInfo.fetchUserInfoError,
    userInfoData: userInfo.userInfoData
  }
}

export default connect(mapStateToProps)(UserInfo)



// WEBPACK FOOTER //
// ./src/pages/UserInfo/UserInfo.js